import React, { forwardRef } from 'react';
import Tooltip from "@mui/material/Tooltip";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import TextField from '@mui/material/TextField';
import '../../styles/steps/ProductsServices.css';

const ProductsServices = forwardRef(({ formData, setFormData, errors, setErrors }, ref) => {
  return (
    <div className="step-container">
      <h3 className="step-title">Add your products or services to help us understand your offerings</h3>
      {/* <p className="step-description">Add your products or services to help us understand your offerings</p> */}
      <div className="form-section">
        <div className="form-group">
          <div className="field-header">
            <label>Products/Services Overview<span className="required-asterisk">*</span></label>
            <Tooltip
              title="Provide a general overview of your products or services"
              arrow
              placement="top"
            >
              <QuestionMarkCircleIcon className="help-icon" />
            </Tooltip>
          </div>
          <TextField
            inputRef={ref}
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            placeholder="Give us a brief overview of your products or services. What do you offer? What makes them special?"
            value={formData.productsData?.overview || ''}
            onChange={(e) => {
              setFormData(prev => ({
                ...prev,
                productsData: {
                  ...prev.productsData,
                  overview: e.target.value
                }
              }));
              // Clear error when user types
              if (errors?.productsOverview) {
                setErrors(prev => ({
                  ...prev,
                  productsOverview: ''
                }));
              }
            }}
            error={!!errors?.productsOverview}
            helperText={errors?.productsOverview}
            required
            className="form-input"
          />
        </div>
      </div>
    </div>
  );
});

ProductsServices.displayName = 'ProductsServices';

export default ProductsServices; 